import { render, staticRenderFns } from "./GradeMappingPanel.vue?vue&type=template&id=5c3285f4&scoped=true"
import script from "./GradeMappingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeMappingPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GradeMappingPanel.vue?vue&type=style&index=0&id=5c3285f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3285f4",
  null
  
)

export default component.exports